/* PTB — Favoris : cœur sur les produits, compteur dans le header, page /pages/favoris.
   Les favoris sont stockés dans le navigateur (localStorage), par appareil. */
(function () {
  var KEY = "ptb:favoris:v1";
  var MAX = 60;
  var lang = (document.documentElement.lang || "fr").slice(0, 2).toLowerCase();
  var T = {
    fr: { add: "Ajouter aux favoris", remove: "Retirer des favoris", added: "Ajouté aux favoris", removed: "Retiré des favoris",
          count: function (n) { return n + (n > 1 ? " articles" : " article"); } },
    en: { add: "Add to favourites", remove: "Remove from favourites", added: "Added to favourites", removed: "Removed from favourites",
          count: function (n) { return n + (n > 1 ? " items" : " item"); } },
    ar: { add: "أضف إلى المفضلة", remove: "إزالة من المفضلة", added: "تمت الإضافة إلى المفضلة", removed: "تمت الإزالة من المفضلة",
          count: function (n) { return n + " منتج"; } }
  };
  var t = T[lang] || T.fr;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || "[]");
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === "string" && h; }) : [];
    } catch (e) { return []; }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    sync();
    document.dispatchEvent(new CustomEvent("ptb:favoris", { detail: { list: read() } }));
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.unshift(handle);
    write(list);
    return i === -1;
  }

  function sync() {
    var list = read();
    document.querySelectorAll("[data-ptb-fav]").forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute("data-handle")) > -1;
      btn.classList.toggle("is-on", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      btn.setAttribute("aria-label", on ? t.remove : t.add);
      btn.setAttribute("title", on ? t.remove : t.add);
    });
    document.querySelectorAll("[data-ptb-fav-count]").forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  function toast(title, sub) {
    var box = document.getElementById("ptb-toasts");
    if (!box) return;
    var el = document.createElement("div");
    el.className = "toast toast--fav";
    el.innerHTML = "<b></b><span></span>";
    el.querySelector("b").textContent = title;
    el.querySelector("span").textContent = sub || "";
    box.appendChild(el);
    window.setTimeout(function () { el.remove(); }, 3000);
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-ptb-fav]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle(btn.getAttribute("data-handle"));
    btn.classList.remove("is-pop");
    void btn.offsetWidth;
    if (on) btn.classList.add("is-pop");
    var card = btn.closest(".card");
    var name = card && card.querySelector("h3") ? card.querySelector("h3").textContent.trim()
      : (document.querySelector(".pdp h1") || {}).textContent || "";
    toast(on ? t.added : t.removed, name.trim());
  });

  window.addEventListener("storage", function (e) {
    if (e.key === KEY) { sync(); document.dispatchEvent(new CustomEvent("ptb:favoris", { detail: { list: read() } })); }
  });

  /* Page Favoris */
  var page = document.querySelector("[data-ptb-fav-page]");
  if (page) {
    var grid = page.querySelector("[data-ptb-fav-grid]");
    var empty = page.querySelector("[data-ptb-fav-empty]");
    var loading = page.querySelector("[data-ptb-fav-loading]");
    var counter = page.querySelector("[data-ptb-fav-page-count]");

    var setCount = function (n) {
      if (counter) counter.textContent = n ? t.count(n) : "";
      if (empty) empty.hidden = n > 0;
      grid.hidden = n === 0;
    };

    var render = function () {
      var list = read();
      if (!list.length) { if (loading) loading.hidden = true; setCount(0); return; }
      Promise.all(list.map(function (handle) {
        return fetch(root + "products/" + encodeURIComponent(handle) + "?view=ptb-card", { credentials: "same-origin" })
          .then(function (r) { return r.ok ? r.text() : null; })
          .catch(function () { return ""; });
      })).then(function (cards) {
        var gone = [];
        grid.innerHTML = "";
        cards.forEach(function (html, i) {
          if (html === null) { gone.push(list[i]); return; }
          if (!html) return;
          var wrap = document.createElement("div");
          wrap.innerHTML = html.trim();
          var card = wrap.querySelector(".card");
          if (card) { card.setAttribute("data-fav-handle", list[i]); grid.appendChild(card); }
        });
        if (gone.length) {
          /* produits supprimés ou dépubliés : on les retire de la liste */
          try { window.localStorage.setItem(KEY, JSON.stringify(read().filter(function (h) { return gone.indexOf(h) === -1; }))); } catch (e) {}
        }
        if (loading) loading.hidden = true;
        sync();
        setCount(grid.querySelectorAll(".card").length);
      });
    };

    document.addEventListener("ptb:favoris", function (e) {
      var list = e.detail.list;
      var known = [];
      grid.querySelectorAll(".card[data-fav-handle]").forEach(function (card) {
        var h = card.getAttribute("data-fav-handle");
        known.push(h);
        if (list.indexOf(h) === -1) {
          card.classList.add("is-leaving");
          window.setTimeout(function () { card.remove(); setCount(grid.querySelectorAll(".card").length); }, 280);
        }
      });
      if (list.some(function (h) { return known.indexOf(h) === -1; })) render();
    });

    render();
  }

  sync();
})();
